import i18next from "i18next";
import React from "react";
import {Button, SemanticCOLORS, SemanticSIZES} from "semantic-ui-react";

interface IShowMoreButtonProps {
    id: number;
    onShowMoreClick: (event: React.MouseEventHandler<{}>, type: string,t:i18next.TranslationFunction<any, object, string>) => void;
    type: string;
    t: i18next.TranslationFunction<any, object, string>;
    color?: SemanticCOLORS;
    size?: SemanticSIZES;
}

// this component can be extended depending on the new usages
export const ShowMoreButton = (props: IShowMoreButtonProps) => {
    const { onShowMoreClick, id, type, t, color, size } = props;
    return (
        <Button className="showmore" size={size} color={color} id={id} data-clicked={`${id}-${type}-NO`} onClick={(e: any) => onShowMoreClick(e, type,t)}>
            {t('KUMA_VIEW:SHOW_MORE')}
        </Button>
    );
};


// WEBPACK FOOTER //
// ./src/components/ShowMoreButton.tsx